import { Nav } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import GameOperationPolicy from './GameOperationPolicy';
import UGCPolicy from './UGCPolicy';

import './TermOfServiceBody.scss';

export const TermOfServiceBody = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const [activeTab, setActiveTab] = useState(tabParam || 'terms');

    useEffect(() => {
        if (tabParam) {
            setActiveTab(tabParam);
        }
    }, [tabParam]);

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
        setSearchParams({ tab });
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'terms':
                return <TermsOfService />;
            case 'privacy':
                return <PrivacyPolicy />;
            case 'game':
                return <GameOperationPolicy />;
            case 'ugc':
                return <UGCPolicy />;
            default:
                return <TermsOfService />;
        }
    };

    return (
        <div className='term-of-service-container'>
            <Nav
                className='nav-tabs'
                variant='tabs'
                defaultActiveKey={activeTab}
            >
                <Nav.Item>
                    <Nav.Link
                        eventKey='terms'
                        onClick={() => handleTabChange('terms')}
                    >
                        Termos de Serviço E EULA
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        eventKey='privacy'
                        onClick={() => handleTabChange('privacy')}
                    >
                        Política de Privacidade
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        eventKey='game'
                        onClick={() => handleTabChange('game')}
                    >
                        Política de Operação do Jogo
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        eventKey='ugc'
                        onClick={() => handleTabChange('ugc')}
                    >
                        Política de UGC
                    </Nav.Link>
                </Nav.Item>
            </Nav>

            <div className='content-container'>{renderContent()}</div>
        </div>
    );
};

export default TermOfServiceBody;
